import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    ownerships: [],
    ownershipsLoading: false,
  },
  mutations: {
    setOwnerships(state, ownerships) {
      state.ownerships = ownerships;
    },
    setOwnershipsLoading(state, loading) {
      state.ownershipsLoading = loading;
    },
  },
  actions: {
    async loadOwnerships({ commit }) {
      commit("setOwnershipsLoading", true);
      let ownerships = await api.get("ownerships");
      commit("setOwnerships", ownerships.data);
      commit("setOwnershipsLoading", false);
    },
    async newOwnership({ commit, dispatch }, payload) {
      await api.post("ownerships", payload);
      dispatch("loadOwnerships");
      dispatch("loadDevices");
    },
    async saveOwnership({ commit, dispatch }, payload) {
      await api.put("ownerships", payload);
      dispatch("loadOwnerships");
    },
    async endOwnership({ commit, dispatch }, payload) {
      await api.put("ownerships/endOwnership", payload);
      dispatch("loadOwnerships");
      dispatch("loadDevices");
      dispatch("loadOrganizations");
    },
  },
  getters: {
    ownershipsLoading(state) {
      return state.ownershipsLoading;
    },
    ownerships(state) {
      return state.ownerships;
    },
  },
};
